<template>
  <div @click="$emit('widgetAdd');">
    <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-message-text"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Входящие</span>
      </v-col>
  </div>
</template>

<script>
export default {
  emits: ["widgetIncoming"], //обязательный для всех виджетов
  props: {
    //обязательный для всех виджетов.клик по иконке. нужно открыть доп. настройки
    //или заэмитить widgetAdd
    showWidgetSettings: {
      required: true,
    },
  },
  name: "incomingSettings",
  data() {
    return {
    };
  },
  watch: {
    
  },
  created() {
    
  },
  methods: {
  }
};
</script>
